<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  methods: {
    load() {
      this.id = this.$route.query.id
      this.$http
        .get(`/bulletins/${this.id}`)
        .then(res => {
          this.bulletin = res.data
        })
        .catch()
    },
    save() {
      this.$http.put(`/bulletins/${this.id}`, this.bulletin).then(() => {
        this.$router.go(-1)
      })
    }
  },
  mounted() {
    this.load()
  }
}
</script>
